import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {

  title: string;
  body: string;
  cancelButtonLabel: string = 'Cancel';
  confirmButtonLabel: string = 'Confirm';

  constructor(@Inject(MAT_DIALOG_DATA) public data: {title: string, body: string, cancelButtonLabel: string , confirmButtonLabel: string, onCancel: any, onConfirm: any}) { }

  ngOnInit(): void {
    this.title = this.data.title;
    this.body = this.data.body;
    if (!this.data.onCancel) {
      this.cancelButtonLabel = "";
    }
    else if (this.data.cancelButtonLabel) {
      this.cancelButtonLabel = this.data.cancelButtonLabel;
    }
    if (!this.data.onConfirm) {
      this.confirmButtonLabel = "";
    }
    else if(this.data.confirmButtonLabel) {
      this.confirmButtonLabel = this.data.confirmButtonLabel;
    }
  }

  cancelButton(){
    this.data.onCancel();
  }
  confirmButton(){
    this.data.onConfirm();
  }

}
